import { render } from "preact";

import "@kroki/ui/tokens.css";
import "./index.css";
import { App } from "./App";

const container = document.getElementById("root");
if (!container) throw new Error("Hiányzik a #root elem");

render(<App />, container);
